import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();

  constructor(private translate: TranslateService) {
    // const userLang = localStorage.getItem('selectedLanguage') || 'en';
    // this.translate.use(userLang);

    const userLang = localStorage.getItem('app-lang') || 'en-US';
    this.translate.use(userLang);
  }
}
